import PropTypes from 'prop-types'
import React from 'react'
import {connect} from 'react-redux'
import {createStructuredSelector} from 'reselect'

import * as pdp from '../../../store/productDetailPage'

const ProductSidebarDetailsList = ({productSetSpecs}) => {
  const specsArray = [
    productSetSpecs.material,
    productSetSpecs.bulletPoint1,
    productSetSpecs.bulletPoint2,
    productSetSpecs.bulletPoint3,
    productSetSpecs.bulletPoint4,
    productSetSpecs.bulletPoint5,
  ].filter(Boolean)

  return (
    <ul className="c-product-sidebar__list">
      {specsArray.map((info) => (
        <li key={info}>{info}</li>
      ))}
    </ul>
  )
}

ProductSidebarDetailsList.propTypes = {
  productSetSpecs: PropTypes.shape({
    material: PropTypes.string,
    bulletPoint1: PropTypes.string,
    bulletPoint2: PropTypes.string,
    bulletPoint3: PropTypes.string,
    bulletPoint4: PropTypes.string,
    bulletPoint5: PropTypes.string,
  }).isRequired,
}

const mapStateToProps = createStructuredSelector({
  productSetSpecs: pdp.productSetSpecs,
})

export default connect(mapStateToProps)(ProductSidebarDetailsList)
